import { AlertCircle, Loader2 } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { type DriverMvrState, MvrStatus } from '../../models/mvr'
import { MvrOutcome } from './MvrOutcome'

/** What the request dialog reports for one driver. */
export function MvrDriverStateCell({ state }: { state: DriverMvrState }) {
  if (!state.eligible) {
    return (
      <span className="text-muted-foreground flex items-center gap-1.5 text-xs">
        <AlertCircle className="size-3.5 shrink-0" />
        Missing {state.missingFields.join(', ').toLowerCase()}
      </span>
    )
  }
  if (state.inFlight) {
    return (
      <span className="text-muted-foreground flex items-center gap-1.5 text-xs">
        <Loader2 className="size-3.5 shrink-0 animate-spin" />
        {state.latestStatus === MvrStatus.PROCESSING ? 'Processing at Checkr' : 'In progress'}
      </span>
    )
  }
  // The newest attempt's outcome comes first: a blank or failed result is why
  // you would pull again, and it must never read as "never pulled".
  if (state.latestStatus === MvrStatus.NO_RECORD || state.latestStatus === MvrStatus.FAILED) {
    return <MvrOutcome state={state} />
  }
  if (!state.lastPulledAt) {
    return <span className="text-muted-foreground text-xs">Never pulled</span>
  }
  // Out of date is a prompt, not a warning — staff decide whether to re-pull.
  return state.isCurrent ? (
    <Badge variant="success">Current</Badge>
  ) : (
    <Badge variant="outline">Out of date</Badge>
  )
}
